import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Support = () => (
  <div className="max-w-4xl mx-auto px-6 py-20 text-center">
    <div className="w-20 h-20 bg-amber-100 dark:bg-amber-900/30 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-8">
      <SafeIcon icon={FiIcons.FiLifeBuoy} className="text-4xl" />
    </div>
    <h1 className="font-serif text-5xl font-bold text-slate-900 dark:text-white mb-6">How can we help?</h1>
    <p className="text-xl text-slate-500 mb-12 max-w-2xl mx-auto">
      Whether you're experiencing a bug or have questions about Big Hook Media Inc.'s platform, our team is here for you.
    </p>
    <div className="bg-slate-50 dark:bg-slate-900 p-8 rounded-3xl border border-slate-200 dark:border-slate-800 inline-block text-left max-w-md w-full">
      <h3 className="text-lg font-bold mb-4">Contact Our Team</h3>
      <div className="flex items-center space-x-4 mb-6">
        <div className="w-10 h-10 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 rounded-lg flex items-center justify-center">
          <SafeIcon icon={FiIcons.FiMail} />
        </div>
        <div>
          <p className="text-xs text-slate-500 uppercase font-bold">Email Support</p>
          <a href="mailto:support@bighookmedia.com" className="text-slate-900 dark:text-white font-medium hover:text-amber-600">support@bighookmedia.com</a>
        </div>
      </div>
      <p className="text-sm text-slate-400 italic">Response time is typically under 24 hours.</p>
    </div>
  </div>
);

export default Support;